import { useQuery } from "@tanstack/react-query";
import type { PtoBalanceResult } from "@/lib/pto-balance";
import { ptoBalanceKeys } from "@/lib/query";

// Derived, read-only — GET only, no mutation hooks (see src/api/pto-balance.ts).
// Mirrors the singleton useAllowancePeriod shape in use-allowance-period.ts.
export function usePtoBalance() {
  return useQuery({
    queryKey: ptoBalanceKeys.detail(),
    queryFn: async (): Promise<PtoBalanceResult> => {
      const res = await fetch("/api/pto-balance");
      if (!res.ok) throw new Error("Failed to fetch PTO balance");
      const json = await res.json();
      return json.data;
    },
  });
}
